import { type ReactElement } from 'react';
import { Outlet } from 'react-router-dom';

import { Toaster } from '@/shared/ui/Sonner';

/**
 * Application root.
 *
 * The `Toaster` goes here and not in each layout. It used to be mounted only
 * in the `(app)` one, so on the login screen — which lives in `(auth)` —
 * `toast()` was called, sonner queued it, and there was nothing in the tree to
 * render it: the incorrect-credentials notice was generated and never appeared.
 *
 * Mounting it at the root covers every route, including any added later. Per
 * layout, each new layout is born with the same problem.
 */
const App = (): ReactElement => {
  return (
    <>
      <Toaster />
      <Outlet />
    </>
  );
};

export default App;
